/* istanbul ignore file */
import { number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { Assignment } from './Assignment';
import { User } from './User';
const AssignmentLoginLinkParser = /* #__PURE__ */ parsers.object([
    ['id', codecString],
    ['assignment', Assignment],
    ['user', User],
    ['timeToStart', /* #__PURE__ */ parsers.maybeNull(codecNumber), 'time_to_start'],
]);
export class AssignmentLoginLink extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AssignmentLoginLinkParser.decode(input).map(res => new AssignmentLoginLink(res));
    }
    static unsafeDecode(input) {
        return AssignmentLoginLink.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AssignmentLoginLinkParser.encode(data);
    }
    static schema() {
        return AssignmentLoginLinkParser.schema();
    }
}
